var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoMotorEngine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M14,19.8l-0.6,1l3.1,1.5v-1.4L14,19.8z M35,22.9c0,0,1,1.7,1,2.2c0,0.5-0.4,0.9-1,0.9c-0.5,0-1-0.4-1-1 C34.1,24.6,35,22.9,35,22.9z M13.5,18.4l4.1,1.8v1.1h2.8v-1.5h-1.7v-1h5v1.1H22v1.6l0.6,0c0.1,0,0.1,0,0.2,0l0.3,0 c0.3,0,0.6,0,0.8,0l0.3,0c0,0,0.1,0,0.1,0l0.2,0c0,0,0,0,0.1,0l0.1,0l2.2,1.7l7-2.6l1.2,1.1l-0.9,0.9L33.6,22l-6.8,6.2l-0.4,0 c0,0-0.1,0-0.1,0l-0.6,0c-0.1,0-0.1,0-0.2,0l-0.6,0c-0.1,0-0.1,0-0.2,0l-0.7,0c-0.1,0-0.2,0-0.2,0l-0.5,0c-0.1,0-0.2,0-0.3,0 l-0.5,0c-0.1,0-0.2,0-0.3,0l-0.8,0c-0.1,0-0.2,0-0.3,0l-0.8,0c-0.1,0-0.2,0-0.3,0l-1.1,0c-0.1,0-0.2,0-0.3,0l-2.1,0 c-0.1,0-0.2,0-0.3,0l0-2.2c0-0.5,0-1.1,0-1.6l0-0.3c0,0,0-0.1,0-0.1l0-0.2c0,0,0-0.1,0-0.1l0-0.1L12,21.3L13.5,18.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoMotorEngine);
export default __webpack_public_path__ + "static/media/ic_bevo_motorEngine.f8e1077ac6568733019e2d27811cbe30.svg";
export { ForwardRef as ReactComponent };